export type Effect = 'appear' | 'fade_in' | 'slide_in';

export default class CharacterCommandOptions {
  // eslint-disable-next-line no-useless-constructor
  constructor(public effect?: Effect, public waiting?: boolean) {}
}
